import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, tap } from 'rxjs';
import { IMunicipalitiesService, MunicipalityManagement, MunicipalityManagementResponse, MunicipalityProvinceResponse, MunicipalityResponse } from './municipalities.interface';
import { environment } from '../../../../environments/environment';
import { LanguageUtils } from '../../utils/language.utils';

@Injectable({
  providedIn: 'root'
})
export class MunicipalitiesService implements IMunicipalitiesService {
  cache1 = new Map<string, MunicipalityResponse>();
  cache2 = new Map<string, MunicipalityProvinceResponse>();
  cache3 = new Map<string, MunicipalityManagementResponse>();

  constructor(private httpClient: HttpClient) { }

  getMunicipalities(): Observable<MunicipalityResponse> {
    const cached = this.cache1.get(LanguageUtils.getLanguage());
    if (cached) {
      return of(cached);
    } else {
      return this.httpClient.get<MunicipalityResponse>(environment.apiPublicUrl + '/municipalities?language=' + LanguageUtils.getLanguage()).pipe(
        tap(data => this.cache1.set(LanguageUtils.getLanguage(), data))
      );
    }
  }

  getMunicipalitiesByProvince(provinceName: string): Observable<MunicipalityProvinceResponse> {
    const cached = this.cache2.get(provinceName + '-' + LanguageUtils.getLanguage());
    if (cached) {
      return of(cached);
    } else {
      return this.httpClient.get<MunicipalityProvinceResponse>(environment.apiPublicUrl + '/municipalities?province=' + provinceName + '&language=' + LanguageUtils.getLanguage()).pipe(
        tap(data => this.cache2.set(provinceName + '-' + LanguageUtils.getLanguage(), data))
      );
    }
  }

  getMunicipalitiesManagement(): Observable<MunicipalityManagementResponse> {
    const cached = this.cache3.get(LanguageUtils.getLanguage());
    if (cached) {
      return of(cached);
    } else {
      return this.httpClient.get<MunicipalityManagementResponse>(environment.apiPublicUrl + '/municipalities/management?language=' + LanguageUtils.getLanguage()).pipe(
        tap(data => this.cache3.set(LanguageUtils.getLanguage(), data))
      );
    }
  }

  getMunicipalitiesManagementDetail(municipalityName: string): Observable<MunicipalityManagement> {
    return this.httpClient.get<MunicipalityManagement>(environment.apiPublicUrl + '/municipalities/management?municipality='+ municipalityName + '&language=' + LanguageUtils.getLanguage());
  }
}
